var React = require('react');

function ARROW (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #ff4401;\n        stroke-linecap: round;\n        stroke-width: 2px;\n      }\n    ")),React.createElement("path",{"id":"Path_7532","data-name":"Path 7532","className":"cls-1","d":"M2646.957-10241.455l9.558,9.559-9.558,9.558","transform":"translate(-2645.542 10242.869)","key":1})]);
}

ARROW.defaultProps = {"width":"12.387","height":"21.944","viewBox":"0 0 12.387 21.944"};

module.exports = ARROW;

ARROW.default = ARROW;
